var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconsDarkInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-dark-info",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1824",
    "data-name": "Group 1824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10432",
    "data-name": "Path 10432",
    d: "M0,0H24V24H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(3 3)",
    fill: "none",
    stroke: "#f60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10.5 6.375)",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10433",
    "data-name": "Path 10433",
    d: "M11.25,11.25H12V16.5h.75",
    fill: "none",
    stroke: "#f60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsDarkInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icons-dark-info.2b01c349.svg";
export { ForwardRef as ReactComponent };